import DetailJobSeeker from "@Molecule/_jobSeekers/DetailJobSeeker";
import HomeFooter from "../HomeFooter";
import Styles from "./styles.module.scss";

export default function PreviewJobPostClient({ getDetailJobPost }) {
  console.log(getDetailJobPost?.response);
  return (
    <div className={Styles.container}>
      <div className={Styles.content}>
        <DetailJobSeeker data={getDetailJobPost?.response} isPreview />
      </div>

      <HomeFooter />
    </div>
  );
}
